import useSWR from 'swr'

export default function useCustomerOrders() {
  // only refresh every 10 seconds to prevent rate limits of paywhirl api
  const { data, error, mutate } = useSWR(`/api/account/orders`, {refreshInterval: 10});
  return {
    orders: data?.orders || undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}


export async function postCustomerOrders(payload: any = {}) {
  return await fetch(`/api/account/orders`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
}
